import { LocalizationProvider as LocalizationProviderRoot } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { PropsWithChildren } from 'react'

export const LocalizationProvider = ({ children }: PropsWithChildren): JSX.Element => (
  <LocalizationProviderRoot dateAdapter={AdapterDayjs}>{children}</LocalizationProviderRoot>
)
